interface ChatMessage {
  id: string
  content: string
  workSpaceId?: string
  userWorkSpaceId?: string
  createdAt: string
  isCurrentUser?: boolean
  user?: {
    id: string
    firstName?: string
    surname?: string
    profileImage?: {
      url?: string
    }
  }
  userId?: string
  firstName?: string
  lastName?: string
  profileImage?: string
  isDeleted?: boolean
}

export const useDashboardChat = () => {
  const messages = ref<ChatMessage[]>([])
  const loading = ref(false)
  const sendingMessage = ref(false)
  const error = ref<string | null>(null)
  const count = ref(0)

  const fetchMessages = async () => {
    loading.value = true
    error.value = null

    try {
      const response = await $fetch(
        `/api/v1/dashboardChat/get-all`,
      )
      console.log('response', response)

      console.log('messages', response.data.messages)
      messages.value = response.data.messages
    }
    catch (err: Error | unknown) {
      error.value = err instanceof Error ? err.message : 'Failed to fetch messages'
    }
    finally {
      loading.value = false
    }
  }

  const sendMessage = async (content: string) => {
    sendingMessage.value = true
    error.value = null

    try {
      const response = await $fetch(
        `/api/v1/dashboardChat/send`,
        {
          method: 'POST',
          body: { content },
        },
      )
      console.log('response', response)

      await fetchMessages()
    }
    catch (err: Error | unknown) {
      error.value = err instanceof Error ? err.message : 'Failed to send message'
    }
    finally {
      sendingMessage.value = false
    }
  }

  const getUnreadCount = async () => {
    try {
      const response = await $fetch(
        `/api/v1/dashboardChat/count`,
      )
      console.log('response', response)
      count.value = response.data.unread || 0
      return count.value
    }
    catch (err: Error | unknown) {
      error.value = err instanceof Error ? err.message : 'Failed to get message count'
      return 0
    }
  }

  return {
    messages,
    loading,
    sendingMessage,
    error,
    count,
    fetchMessages,
    sendMessage,
    getUnreadCount,
  }
}

export default useDashboardChat
